export enum Routes {
  RULES = 'rules',
  SKILL_OR_CHANCE = 'skill_or_chance',
  STRATEGY_TIPS = 'strategy_tip',
  HISTORY = 'history',
}
